import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import {
  Button,
  Col,
  Form,
  ListGroup,
  Modal,
  Pagination,
  Row,
  Spinner,
  Table
} from 'react-bootstrap';
import Select from 'react-select';
import { TrashFill, PencilFill, ChevronUp, ChevronDown, PlusCircleFill, Download } from 'react-bootstrap-icons';
import makeAnimated from "react-select/animated";
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';
import { useSelector } from 'react-redux';

const NewMenuAddons = () => {
  
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [menuAccess, setMenuAccess] = useState([])
  
  console.log("Access :", access);
  
  useEffect(() => {
      if (Array.isArray(access)) {
          const filteredAccess = access?.filter((perm) =>
              perm?.startsWith("AddonGroups:")
          );
          setMenuAccess(filteredAccess);
      } 
  }, [access]);
  
  console.log("Menu Access:", menuAccess);

  const accessToken = localStorage.getItem("authToken");
  const animatedComponents = makeAnimated();
  const [outlets, setOutlets] = useState([]);
  const [addonList, setAddonList] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [removedBadgeImage, setRemovedBadgeImage] = useState(false);
  const [removedSelectedImages, setRemovedSelectedImages] = useState({});
  const [removedNonSelectedImages, setRemovedNonSelectedImages] = useState({});


  // Modal state for adding a new addon group
  const [addGroupModalOpen, setAddGroupModalOpen] = useState(false);
  const [groupFormData, setGroupFormData] = useState({
    title: "",
    sequenceNumber: "",
    isMultipleSelect: false,
    groupSequence: "",
    identifier: "",
    orderType: "ALL",
    groupStatus: "INACTIVE",
    addonValues: [
      {
        icon: "", // Omitted in payload for now
        sequenceNumber: "",
        value: "",
        orderType: "ALL",
        productCost: 0,
        status: "INACTIVE", // Default status
        excludedOutlets: [] // Array of react‑select option objects
      }
    ],
    excludedOutlets: [],
    description: ''
  });
  const [badgeImage, setBadgeImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [nonSelectedImage, setNonSelectedImage] = useState(null);

  const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
  const [currentEditGroup, setCurrentEditGroup] = useState(null);
  const [confirmDeleteValueModalOpen, setConfirmDeleteValueModalOpen] = useState(false);
  const [deleteValueInfo, setDeleteValueInfo] = useState({ groupId: null, valueId: null });

  // Modal state for editing an individual addon value
  const [editValueModalOpen, setEditValueModalOpen] = useState(false);
  const [addValueModalOpen, setAddValueModalOpen] = useState(false);
  const [currentEditValue, setCurrentEditValue] = useState(null); // Stores the addon value to edit
  const [currentGroupIdForValue, setCurrentGroupIdForValue] = useState(null); // The parent group ID
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [groupIdToDelete, setGroupIdToDelete] = useState(null);
  const [editSelectedImages, setEditSelectedImages] = useState({});
  const [editNonSelectedImages, setEditNonSelectedImages] = useState({});
  const [editBadgeImage, setEditBadgeImage] = useState(null);

  // Pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState('');
  const [totalRecords, setTotalRecords] = useState('');

  const [searchText, setSearchText] = useState('');
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  // Map outlets to react-select options
  const outletData = outlets.map((outlet) => ({
    value: outlet._id,
    label: `${outlet.name} (${outlet.city})`
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "6px",
      minWidth: "200px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da"
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d"
    })
  };

  // Fetch outlets
  const getOutlets = async () => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.get("outlet", { headers });
      if (response?.data?.status === true) {
        const filteredOutlets = response.data.data.outlets.filter(
          (act) => act.status === "ACTIVE"
        );
        setOutlets(filteredOutlets);
      }
    } catch (error) {
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  // Fetch addon groups
  const getAddons = async (pageno, recordsPerPage, search) => {
    try {
      const headers = { 
        Authorization: `Bearer ${accessToken}` 
      };

      let url = `addons?page=${pageno}&limit=${recordsPerPage}`;
      if (search) {
        url += `&search=${search}`;
      }

      const response = await axiosInstance.get(url, { headers });
      if (response?.data?.status === true) {
        setAddonList(response?.data?.data?.addons || []);
        setTotalPages(response?.data?.data?.pagination?.totalPages);
        setTotalRecords(response?.data?.data?.pagination?.totalRecords);
      }
    } catch (error) {
      console.log("Erorrrr : ", error);
      
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  // Download Addon Groups
  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const headers = { 
        Authorization: `Bearer ${accessToken}`,
      };
      
      // Build URL with isDownload flag
      let url = `addons?isDownload=true`;
      
      const response = await axiosInstance.get(url, { 
        headers,
        responseType: 'arraybuffer'
      });
      
      // Check content type
      const contentType = response.headers['content-type'] || '';
      
      // If response is JSON (error case), parse it
      if (contentType.includes('application/json')) {
        const decoder = new TextDecoder('utf-8');
        const text = decoder.decode(new Uint8Array(response.data));
        const errorData = JSON.parse(text);
        toast.error(errorData.error || errorData.message || "Failed to download addon groups");
        setDownloadLoading(false);
        return;
      }
      
      // Generate standardized filename with timestamp
      const date = new Date();
      const timestamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`;
      
      // Create filename
      let filename = `Addon Groups`;
      
      // Determine file extension based on content type
      if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        filename += '.xlsx';
      } else if (contentType.includes('application/vnd.ms-excel')) {
        filename += '.xls';
      } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
        filename += '.csv';
      } else {
        filename += '.xlsx';
      }
      
      // Create blob with proper MIME type
      const blob = new Blob([response.data], { 
        type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Verify file is not empty
      if (blob.size === 0) {
        toast.error("Downloaded file is empty");
        setDownloadLoading(false);
        return;
      }
      
      // Create download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, 200);
      
      toast.success("Addon groups downloaded successfully!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } catch (error) {
      console.error("Download error:", error);
      
      // Handle error responses
      if (error.response?.data instanceof ArrayBuffer || error.response?.data instanceof Uint8Array) {
        try {
          const decoder = new TextDecoder('utf-8');
          const text = decoder.decode(new Uint8Array(error.response.data));
          const errorData = JSON.parse(text);
          toast.error(errorData.error || errorData.message || "Failed to download addon groups");
        } catch {
          toast.error("Failed to download addon groups. The server returned an unexpected response.");
        }
      } else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to download addon groups. Please try again.");
      }
    } finally {
      setDownloadLoading(false);
    }
  };

  useEffect(() => {
    getOutlets();
    getAddons(page, limit);
  }, []);

  // ---------------------------
  // Handlers for Add Group Modal
  // ---------------------------

  const handleBadgeImageChange = () => {
    const input = document.getElementById("badgeImageInput");
    const file = input?.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const image = new Image();
        image.src = reader.result;
        setBadgeImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSelectedImageChange = (index) => (e) => {
    const file = e.target.files[0];
    if (file) {
      setGroupFormData((prev) => {
        const updated = [...prev.addonValues];
        updated[index].selectedImage = file;
        return { ...prev, addonValues: updated };
      });
    }
  };

  const handleUnSelectedImageChange = (index) => (e) => {
    const file = e.target.files[0];
    if (file) {
      setGroupFormData((prev) => {
        const updated = [...prev.addonValues];
        updated[index].nonSelectedImage = file;
        return { ...prev, addonValues: updated };
      });
    }
  };

  const handleGroupInputChange = (e, index) => {
    const { name, value } = e.target;
    if (name === "title") {
      setGroupFormData((prev) => ({ ...prev, title: value }));
    } else if (name === "sequenceNumbers") {
      setGroupFormData((prev) => ({ ...prev, sequenceNumber: value }));
    } else if (name === "description") {
      setGroupFormData((prev) => ({ ...prev, description: value }));
    } else if (name === "ordersType") {
      setGroupFormData((prev) => ({ ...prev, orderType: value }));
    } else if (name === "identifier") {
      setGroupFormData((prev) => ({ ...prev, identifier: value }));
    } else if (name === "isMultipleSelect") {
      setGroupFormData((prev) => ({ ...prev, isMultipleSelect: e.target.checked }));
    } else if (name === "groupSequence") {
      setGroupFormData((prev) => ({ ...prev, groupSequence: value }));
    } else {
      setGroupFormData((prev) => {
        const updatedAddonValues = [...prev.addonValues];
        updatedAddonValues[index] = { 
          ...updatedAddonValues[index], 
          [name]: name === "isMultipleSelect" ? e.target.checked : value 
        };
        return { ...prev, addonValues: updatedAddonValues };
      });
    }
  };

  const handleGroupSelectChange = (selected, index, isGroup = false) => {
    if (isGroup) {
      setGroupFormData((prev) => ({ ...prev, excludedOutlets: selected || [] }));
    } else {
      setGroupFormData((prev) => {
        const updatedAddonValues = [...prev.addonValues];
        updatedAddonValues[index] = {
          ...updatedAddonValues[index],
          excludedOutlets: selected || []
        };
        return { ...prev, addonValues: updatedAddonValues };
      });
    }
  };

  const handleAddNewAddonValue = () => {
    setGroupFormData((prev) => ({
      ...prev,
      addonValues: [
        ...prev.addonValues,
        {
          icon: "",
          sequenceNumber: prev.addonValues.length + 1,
          value: "",
          status: "INACTIVE",
          excludedOutlets: []
        }
      ]
    }));
  };

  const handleRemoveAddonValueLocal = (index) => {
    setGroupFormData((prev) => {
      const updatedAddonValues = prev.addonValues.filter((_, i) => i !== index);
      updatedAddonValues.forEach((item, idx) => {
        item.sequenceNumber = idx + 1;
      });
      return { ...prev, addonValues: updatedAddonValues };
    });
  };

  const handleGroupSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append("title", groupFormData.title);
    formData.append("sequenceNumber", groupFormData.sequenceNumber);
    formData.append("orderType", groupFormData.orderType);
    if (groupFormData.description) {
      formData.append("description", groupFormData.description);  
    }
    if (groupFormData.identifier) {
      formData.append("identifier", groupFormData.identifier);
    }
    if(groupFormData.isMultipleSelect) {
      formData.append("isMultipleSelect", groupFormData.isMultipleSelect)
    }
  
    if (badgeImage) {
      formData.append("badgeImage", badgeImage);
    }

    groupFormData.addonValues.forEach((addon, index) => {
      if (addon.selectedImage) {
        formData.append(`addonValues[${index}][selectedImage]`, addon.selectedImage);
      }
      if (addon.nonSelectedImage) {
        formData.append(`addonValues[${index}][nonSelectedImage]`, addon.nonSelectedImage);
      }
    });

    const addonValuesPayload = groupFormData.addonValues.map((addon) => ({
      sequenceNumber: Number(addon.sequenceNumber),
      value: addon.value,
      orderType: addon.orderType,
      productCost: addon.productCost,
      status: addon.status,
      excludedOutlets: addon.excludedOutlets.map((opt) => opt.value)
    }));
    formData.append("addonValues", JSON.stringify(addonValuesPayload));
  
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data"
      };
  
      const response = await axiosInstance.post("addons", formData, { headers });
  
      if (response?.data?.status === true) {
        toast.success("Addon group created successfully!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
  
        setGroupFormData({
          groupSequence: "",
          title: "",
          identifier: "",
          orderType: "ALL",
          badgeImage: null,
          isMultipleSelect: false,
          addonValues: [
            {
              icon: "",
              sequenceNumber: 1,
              value: "",
              orderType: "ALL",
              productCost: "",
              status: "INACTIVE",
              excludedOutlets: [],
              selectedImage: null,
              nonSelectedImage: null
            }
          ],
          excludedOutlets: [],
          description: ''
        });
  
        setAddGroupModalOpen(false);
        getAddons(page, limit, searchText);
      } else {
        toast.error("Failed to create addon group", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
      }
    } catch (error) {
      if (error?.response) {
        console.log("error :", error);
        
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 400) {
          errorMessage = error?.response?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };
  

  // ---------------------------
  // Handlers for Editing Entire Group
  // ---------------------------
  const openEditGroup = (group) => {
    console.log("Edit open group- :", group);
    
    setCurrentEditGroup({
      ...group,
      badgeImage: group.badgeImage,
      sequenceNumber: group.sequenceNumber,
      status: group.status,
      isMultipleSelect: group.isMultipleSelect ,
      description: group.description,
      orderType: group.orderType,
      excludedOutlets: group.excludedOutlets.map((out) => ({
        value: out._id,
        label: out.name
      })),
      addonValues: group.addonValues.map((addon) => ({
        ...addon,
        excludedOutlets: addon.excludedOutlets.map((out) => ({
          value: out._id,
          label: out.name
        }))
      }))
    });
    setEditGroupModalOpen(true);
  };
  
  const handleEditBadgeImageChange = () => {
    const input = document.getElementById("badgeImageInput");
    const file = input?.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const image = new Image();
        image.src = reader.result;
        setEditBadgeImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditSelectedImageChange = (e, index) => {
    const file = e.target.files[0];
    setEditSelectedImages((prev) => ({ ...prev, [index]: file }));
  };
  
  const handleEditUnSelectedImageChange = (e, index) => {
    const file = e.target.files[0];
    setEditNonSelectedImages((prev) => ({ ...prev, [index]: file }));
  };

  const handleEditGroupInputChange = (e, index) => {
    const { name, value } = e.target;

    console.log("Name :", name, "Value :", value);
    
    if (name === "title") {
      setCurrentEditGroup((prev) => ({ ...prev, title: value }));
    } else if (name === "sequenceNumbers") {
      setCurrentEditGroup((prev) => ({ ...prev, sequenceNumber: value }));
    } else if (name === "ordersType") {
      setCurrentEditGroup((prev) => ({ ...prev, orderType: value }));
    } else if (name === "description") {
      setCurrentEditGroup((prev) => ({ ...prev, description: value }));
    } else if (name === "identifier") {
      setCurrentEditGroup((prev) => ({ ...prev, identifier: value }));
    } else if (name === "isMultipleSelect") {
      setCurrentEditGroup((prev) => ({ ...prev, isMultipleSelect: e.target.checked }));
    } else {
      setCurrentEditGroup((prev) => {
        const updatedAddonValues = [...prev.addonValues];
        updatedAddonValues[index] = { ...updatedAddonValues[index], [name]: value };
        return { ...prev, addonValues: updatedAddonValues };
      });
    }
  };

  const handleEditGroupSelectChange = (selected, index, isGroup = false) => {
    if (isGroup) {
      setCurrentEditGroup((prev) => ({ ...prev, excludedOutlets: selected || [] }));
    } else {
      setCurrentEditGroup((prev) => {
        const updatedAddonValues = [...prev.addonValues];
        updatedAddonValues[index] = {
          ...updatedAddonValues[index],
          excludedOutlets: selected || []
        };
        return { ...prev, addonValues: updatedAddonValues };
      });
    }
  };

  const handleAddNewEditAddonValue = () => {
    setCurrentEditGroup((prev) => ({
      ...prev,
      addonValues: [
        ...prev.addonValues,
        {
          icon: "",
          sequenceNumber: prev.addonValues.length + 1,
          value: "",
          status: 'INACTIVE',
          excludedOutlets: []
        }
      ]
    }));
  };

  const handleRemoveEditAddonValue = (index) => {
    setCurrentEditGroup((prev) => {
      const updatedAddonValues = prev.addonValues.filter((_, i) => i !== index);
      updatedAddonValues.forEach((item, idx) => {
        item.sequenceNumber = idx + 1;
      });
      return { ...prev, addonValues: updatedAddonValues };
    });
  };

  const handleEditGroupSubmit = async (e) => {
    e.preventDefault();
    setIsEditBtnLoading(true);
    const formData = new FormData();
    formData.append("_id", currentEditGroup?._id);
    formData.append("title", currentEditGroup?.title);
    formData.append("status", currentEditGroup?.status);
    formData.append("sequenceNumber", currentEditGroup?.sequenceNumber);
    formData.append("isMultipleSelect", currentEditGroup?.isMultipleSelect);
    formData.append("orderType", currentEditGroup?.orderType);

    if (currentEditGroup?.description) {
      formData.append("description", currentEditGroup?.description); 
    } else {
      formData.append("description", null);
    }

    if (currentEditGroup.identifier) {
      formData.append("identifier", currentEditGroup?.identifier);
    } else {
      formData.append("identifier", null);
    }

    if (editBadgeImage) {
      formData.append("badgeImage", editBadgeImage);
    } else if (removedBadgeImage) {
      formData.append("badgeImage", null);
    }

    currentEditGroup?.addonValues?.forEach((addon, index) => {
      if (editSelectedImages[index]) {
        formData.append(`addonValues[${index}][selectedImage]`, editSelectedImages[index]);
      } else if (removedSelectedImages[index]) {
        formData.append(`addonValues[${index}][selectedImage]`, null);
      }

      if (editNonSelectedImages[index]) {
        formData.append(`addonValues[${index}][nonSelectedImage]`, editNonSelectedImages[index]);
      } else if (removedNonSelectedImages[index]) {
        formData.append(`addonValues[${index}][nonSelectedImage]`, null);
      }
    });
  
    const addonValuesPayload = currentEditGroup?.addonValues?.map((addon) => ({
      _id: addon?._id,
      sequenceNumber: addon?.sequenceNumber,
      value: addon?.value,
      status: addon?.status,
      productCost: addon?.productCost,
      orderType: addon?.orderType,
      excludedOutlets: addon?.excludedOutlets?.map((opt) => opt?.value)
    }));
    console.log("addonValuesPayload :", addonValuesPayload);
    
    formData.append("addonValues", JSON.stringify(addonValuesPayload));
  
    formData.append("excludedOutlets", JSON.stringify(
      currentEditGroup?.excludedOutlets?.map((opt) => opt?.value)
    ));
  
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data"
      };
  
      const response = await axiosInstance.put("addons", formData, { headers });
  
      if (response?.data?.status === true) {
        toast.success("Addon group updated successfully!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
        setEditGroupModalOpen(false);
        getAddons(page, limit, searchText);
      } else {
        toast.error("Failed to update addon group", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
      }
    } catch (error) {
      if (error?.response) {
        console.log("Erorr ", error);
        
        let errorMessage = "";
        if (error?.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 400) {
          errorMessage = error?.response?.data?.error || error?.response?.data?.message;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally { 
      setIsEditBtnLoading(false);
    }
  };
  

  const openAddNewAddonValue = (group) => {
    const newSeq = group?.addonValues?.length + 1;
    setCurrentEditValue({
      sequenceNumber: newSeq,
      value: "",
      status: "INACTIVE",
      excludedOutlets: []
    });
    setCurrentGroupIdForValue(group?._id);
    setAddValueModalOpen(true);
  };

  const openEditAddonValue = (groupId, addonValue) => {
    setCurrentEditValue({
      ...addonValue,
      status: addonValue?.status || "INACTIVE",
      orderType: addonValue?.orderType,
      productCost: addonValue?.productCost,
      excludedOutlets: addonValue?.excludedOutlets?.map((out) => ({
        value: out?._id,
        label: out?.name
      }))
    });
    setCurrentGroupIdForValue(groupId);
    setEditValueModalOpen(true);
  };

  const handleEditValueInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentEditValue((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditValueSelectChange = (selected) => {
    setCurrentEditValue((prev) => ({ ...prev, excludedOutlets: selected || [] }));
  };

  const handleEditValueSubmit = async (e) => {
    e.preventDefault();
  
    const groupToUpdate = addonList.find(group => group?._id === currentGroupIdForValue);
    if (!groupToUpdate) {
      toast.error("Parent addon group not found.");
      return;
    }
  
    const updatedGroup = { ...groupToUpdate };
    let valueFound = false;
  
    updatedGroup.addonValues = updatedGroup?.addonValues?.map((val) => {
      if (val._id === currentEditValue._id) {
        valueFound = true;
        return {
          ...currentEditValue,
          excludedOutlets: currentEditValue.excludedOutlets.map(opt => opt.value)
        };
      }
      return val;
    });
  
    if (!valueFound) {
      updatedGroup.addonValues.push({
        ...currentEditValue,
        excludedOutlets: currentEditValue.excludedOutlets.map(opt => opt.value)
      });
    }
  
    updatedGroup.excludedOutlets = updatedGroup.excludedOutlets.map(out => out._id);
  
    const formData = new FormData();
    formData.append("_id", updatedGroup._id);
    formData.append("title", updatedGroup.title);
    formData.append("sequenceNumber", updatedGroup.sequenceNumber);
    formData.append("isMultipleSelect", updatedGroup.isMultipleSelect);
  
    updatedGroup.addonValues.forEach((val, index) => {
      if (val.selectedImage instanceof File) {
        formData.append(`addonValues[${index}][selectedImage]`, val.selectedImage);
      }
      if (val.nonSelectedImage instanceof File) {
        formData.append(`addonValues[${index}][nonSelectedImage]`, val.nonSelectedImage);
      }
    });
  
    const addonValuesMeta = updatedGroup?.addonValues?.map(val => ({
      _id: val._id,
      sequenceNumber: Number(val.sequenceNumber),
      value: val.value,
      status: val.status,
      excludedOutlets: val.excludedOutlets,
      orderType: val.orderType,
      productCost: val.productCost
    }));
    formData.append("addonValues", JSON.stringify(addonValuesMeta));
  
    formData.append("excludedOutlets", JSON.stringify(updatedGroup.excludedOutlets));
  
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data"
      };
  
      const response = await axiosInstance.put("addons", formData, { headers });
  
      if (response?.data?.status === true) {
        toast.success("Addon group updated!");
        setEditValueModalOpen(false);
        getAddons(page, limit, searchText);
        setAddValueModalOpen(false);
      } else {
        toast.error("Failed to update addon group");
      }
    } catch (error) {
      console.log("error :", error);
      
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 400) {
          errorMessage = error?.response?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };
  

  const handleDeleteGroup = async (groupId) => {
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.delete("addons", {
        headers,
        data: { _id: groupId }
      });
      if (response?.data?.status === true) {
        toast.success("Addon group deleted!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
        getAddons(page, limit, searchText);
      } else {
        toast.error("Failed to delete addon group", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
      }
    } catch (error) {
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const handleDeleteAddonValue = async (groupId, valueId) => {
    const groupToUpdate = addonList.find(group => group._id === groupId);
    if (!groupToUpdate) {
      toast.error("Parent addon group not found.");
      return;
    }
    const updatedAddonValues = groupToUpdate.addonValues.filter(val => val._id !== valueId);
    updatedAddonValues.forEach((item, idx) => {
      item.sequenceNumber = idx + 1;
    });
    const payload = {
      _id: groupToUpdate._id,
      title: groupToUpdate.title,
      sequenceNumber: groupToUpdate.sequenceNumber,
      isMultipleSelect: groupToUpdate.isMultipleSelect,
      addonValues: updatedAddonValues.map(val => ({
        _id: val._id,
        sequenceNumber: val.sequenceNumber,
        value: val.value,
        status: val.status,
        excludedOutlets: val.excludedOutlets
      })),
      excludedOutlets: groupToUpdate.excludedOutlets.map(opt => opt._id)
    };
    try {
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.put("addons", payload, { headers });
      if (response?.data?.status === true) {
        toast.success("Addon value deleted!", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
        setConfirmDeleteValueModalOpen(false);
        getAddons(page, limit, searchText);
      } else {
        toast.error("Failed to delete addon value", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
      }
    } catch (error) {
      console.log("Error In Delete :", error);
      
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 400) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const toggleRow = (groupId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const handlePageChange = (pag) => {
    console.log("Data :", pag);
    setPage(pag);
    getAddons(pag, limit, searchText)
  };

  const handleLimitChange = (lim) => {
    setLimit(lim);
    getAddons(1, lim, searchText);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSubmitSearch = async() => {
    setIsSearchLoading(true);
    await getAddons(page, limit, searchText);
    setIsSearchLoading(false);
  }

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
          <Row>
            <Col className="pt-4">
              <h5 className="fw-semibold">ADDON GROUPS</h5>
            </Col>
            <hr />
          </Row>
          <Row className='justify-content-between mb-3'>
            <Col lg="6">
              <div className="d-flex gap-4">
                <div className="input-group w-75">
                    <input
                        type="text"
                        value={searchText}
                        onChange={handleSearchChange}
                        className="form-control"
                        placeholder="Search by addon title..."
                    />
                    <button className="btn btn-primary" type="button" onClick={handleSubmitSearch}>
                        { isSearchLoading ? <Spinner size='sm' /> : <>  <i className="ri-search-line"></i> Search </> }
                    </button>
                </div>
                {(menuAccess.includes("AddonGroups:get") || email === "contact@xpansecafe.com") && (
                  <Button
                    variant="success"
                    onClick={handleDownload}
                    disabled={downloadLoading}
                    className="d-flex align-items-center justify-content-center gap-1 w-25"
                  >
                    {downloadLoading ? (
                      <Spinner size="sm" animation="border" />
                    ) : (
                      <Download size={16} />
                    )}
                    {downloadLoading ? " Downloading..." : " Download"}
                  </Button>
                )}
              </div>
            </Col>
            {(menuAccess.includes("AddonGroups:add") || email === "contact@xpansecafe.com") && (
              <Col className='text-end'>
                <Button variant="primary" onClick={() => setAddGroupModalOpen(true)}>
                  <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                  Add Addon Group
                </Button>
              </Col>
            )}
          </Row>

          {addonList.length > 0 ? (
            <>
              <Table striped bordered hover responsive className="table-hover">
                <thead className="table-dark">
                  <tr>
                    <th>Seq</th>
                    <th>Title</th>
                    <th>Addon Values</th>
                    <th>Group Excluded Outlets</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {addonList.map((group, index) => (
                    <React.Fragment key={group._id}>
                      <tr>
                        <td>
                          <span className="fw-bold">{group.sequenceNumber}</span>{" "}
                        </td>
                        <td>
                          <span className="fw-bold">{group.title}</span>{" "}
                          {group.isMultipleSelect && (
                            <span className="badge ms-2" style={{ backgroundColor: "#1e3a8a", color: "#fff" }}>
                              Multiple Select
                            </span>
                          )}
                        </td>
                        <td>
                          {group.addonValues && group.addonValues.length > 0 ? (
                            <span>{group.addonValues.length} value{group.addonValues.length > 1 && "s"}</span>
                          ) : (
                            <em>No values</em>
                          )}
                        </td>
                        <td>
                          {group.excludedOutlets && group.excludedOutlets.length > 0
                            ? group.excludedOutlets.map((out) => out.name).join(", ")
                            : "None"}
                        </td>
                        <td className="text-center">
                          {(menuAccess.includes("AddonGroups:update") || email === "contact@xpansecafe.com") && (
                            <Button className='me-1' variant="outline-primary" size="sm" onClick={() => openEditGroup(group)}>
                              <PencilFill size={16} /> Edit Group
                            </Button>
                          )}
                          {(menuAccess.includes("AddonGroups:delete") || email === "contact@xpansecafe.com") && (
                            <Button className='me-1' variant="outline-danger" size="sm"
                              onClick={() => {
                                setGroupIdToDelete(group._id);
                                setConfirmDeleteModalOpen(true);
                              }}
                            >
                              <TrashFill size={16} /> Delete Group
                            </Button>
                          )}
                          {group.addonValues && group.addonValues.length > 0 && (
                            <Button className='me-1' variant="outline-secondary" size="sm" onClick={() => toggleRow(group._id)}>
                              {expandedRows[group._id] ? (
                                <>
                                  <ChevronUp size={16} /> Hide Values
                                </>
                              ) : (
                                <>
                                  <ChevronDown size={16} /> View Values
                                </>
                              )}
                            </Button>
                          )}
                        </td>
                      </tr>
                      {expandedRows[group._id] && (
                        <tr>
                          <td colSpan="6" className="bg-light">
                            <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
                              <h6 className="mb-0">Addon Values</h6>
                              {(menuAccess.includes("AddonGroups:add") || email === "contact@xpansecafe.com") && (
                                <Button
                                  variant="outline-success"
                                  size="sm"
                                  style={{ display: "flex", alignItems: "center" }}
                                  onClick={() => openAddNewAddonValue(group)}
                                >
                                  <PlusCircleFill size={20} className="me-1" /> Add Value
                                </Button>
                              )}
                            </div>

                            <ListGroup variant="flush" className="mt-2">
                              {group.addonValues.map((val, idx) => (
                                <ListGroup.Item
                                  key={val._id || idx}
                                  className="d-flex justify-content-between align-items-center"
                                >
                                  <div>
                                    <strong>{val.sequenceNumber}.</strong> {val.value}{" "}
                                    {val.excludedOutlets && val.excludedOutlets.length > 0 && (
                                      <small className="ms-2 text-muted">
                                        - Excluded: {val.excludedOutlets.map((out) => out.name).join(", ")}
                                      </small>
                                    )}
                                    <span className={`ms-2 badge ${val.status === "ACTIVE" ? "bg-success" : "bg-danger"}`}>
                                      {val.status}
                                    </span>
                                    { val.description ? (
                                      <span className='ms-2'>
                                        {val.description}
                                      </span>
                                    ) : null }
                                    
                                  </div>
                                  <div>
                                    {(menuAccess.includes("AddonGroups:update") || email === "contact@xpansecafe.com") && (
                                      <Button
                                        variant="link"
                                        size="sm"
                                        onClick={() => openEditAddonValue(group._id, val)}
                                      >
                                        Edit
                                      </Button>
                                    )}
                                    {(menuAccess.includes("AddonGroups:delete") || email === "contact@xpansecafe.com") && (
                                      <Button variant="link" size="sm"
                                        onClick={() => {
                                          setDeleteValueInfo({ groupId: group._id, valueId: val._id });
                                          setConfirmDeleteValueModalOpen(true);
                                        }}
                                      >
                                        <TrashFill style={{ color: "red" }} />
                                      </Button>
                                    )}
                                  </div>
                                </ListGroup.Item>
                              ))}
                            </ListGroup>
                          </td>
                        </tr>
                      )}

                    </React.Fragment>
                  ))}
                </tbody>
              </Table>

              <hr className='mt-0' />
              <div className="d-flex justify-content-between align-items-center mt-1 pb-4">
                <div className="d-flex align-items-center">
                  <span className="me-2 text-muted">Rows per page:</span>
                  <Form.Select
                    size="sm"
                    value={limit}
                    onChange={(e) => handleLimitChange(Number(e.target.value))}
                    style={{ width: "80px" }}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </Form.Select>
                </div>

                <div className="text-muted">
                  Page {page} of {totalPages} | Total: {totalRecords} records
                </div>

                <Pagination className="mb-0">
                  <Pagination.First disabled={page === 1} onClick={() => handlePageChange(1)} />
                  <Pagination.Prev disabled={page === 1} onClick={() => handlePageChange(page - 1)} />

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                    <Pagination.Item
                      key={pg}
                      active={page === pg}
                      onClick={() => handlePageChange(pg)}
                    >
                      {pg}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next disabled={page === totalPages} onClick={() => handlePageChange(page + 1)} />
                  <Pagination.Last disabled={page === totalPages} onClick={() => handlePageChange(totalPages)} />
                </Pagination>
              </div>

            </>
            
          ) : (
            <p className="text-center text-muted">No addon groups available.</p>
          )}
        </div>

      </div>

      {/* Modal for Adding New Addon Group */}
      {addGroupModalOpen ? (
        <Modal show={addGroupModalOpen} onHide={() => setAddGroupModalOpen(false)} size="lg">
          <Form onSubmit={handleGroupSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>ADD NEW ADDON GROUPS</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-3 align-items-end">
                <Col md={4}>
                  <Form.Group controlId="groupTitle">
                    <Form.Label className='fw-semibold'>Title <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={groupFormData.title}
                      onChange={handleGroupInputChange}
                      placeholder="Enter addon group title"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="groupIdentifier">
                    <Form.Label className='fw-semibold'>Sequence Number <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      step="any"
                      name="sequenceNumbers"
                      value={groupFormData.sequenceNumber}
                      onChange={handleGroupInputChange}
                      placeholder="Enter Sequence Number"
                    />
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group>
                    <Form.Label className='fw-semibold'>
                      Choose Badge Image
                    </Form.Label>
                    <Form.Control
                      id="badgeImageInput"
                      type="file"
                      accept="image/*"
                      onChange={handleBadgeImageChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3 align-items-center">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label className='fw-semibold'>
                            Order Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                            name="ordersType"
                            value={groupFormData.orderType || ""}
                            onChange={handleGroupInputChange}
                        >
                            <option value="ALL">ALL</option>
                            <option value="DELIVERY">DELIVERY</option>
                            <option value="PICKUP">PICK-UP</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group controlId="groupIdentifier">
                    <Form.Label className='fw-semibold'>Size Identifier</Form.Label>
                    <Form.Control
                      type="text"
                      name="identifier"
                      value={groupFormData.identifier}
                      onChange={handleGroupInputChange}
                      placeholder="Enter Size Identifier"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="isMultipleSelect" className="mt-2 fw-semibold">
                    <Form.Check
                      type="checkbox"
                      label="Multiple Select"
                      name="isMultipleSelect"
                      checked={groupFormData?.isMultipleSelect}
                      onChange={handleGroupInputChange}
                      style={{ cursor: 'pointer' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <hr />
              <h5 className='fw-semibold'>ADDON VALUES</h5>
              {groupFormData?.addonValues?.map((item, index) => (
                <Row key={index} className="pt-1 mb-3 align-items-end" style={{ backgroundColor: 'whitesmoke' }}>
                  <Col md={2}>
                    <Form.Group controlId={`sequenceNumber-${index}`}>
                      <Form.Label>Seq. No. <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        type="number"
                        min={0}
                        placeholder='Seq. No'
                        step="any"
                        name="sequenceNumber"
                        value={item.sequenceNumber}
                        onChange={(e) => handleGroupInputChange(e, index)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId={`value-${index}`}>
                      <Form.Label>Value <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        type="text"
                        name="value"
                        value={item.value}
                        onChange={(e) => handleGroupInputChange(e, index)}
                        placeholder="Enter value"
                        required
                      />
                    </Form.Group>
                  </Col>
                  
                  <Col md={6}>
                    <Form.Group controlId={`excludedOutlets-${index}`}>
                      <Form.Label>Excluded Outlets</Form.Label>
                      <Select
                        isMulti
                        options={outletData}
                        value={item.excludedOutlets}
                        onChange={(selected) => handleGroupSelectChange(selected, index)}
                        components={animatedComponents}
                        styles={customStyles}
                        placeholder="Select outlets..."
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group controlId={`status-${index}`}>
                      <Form.Label className="mb-1">Status</Form.Label>
                      <Form.Check
                        type="switch"
                        id={`status-switch-${index}`}
                        label={item.status === "ACTIVE" ? "Active" : "Inactive"}
                        checked={item.status === "ACTIVE"}
                        onChange={(e) => {
                          handleGroupInputChange(
                            {
                              target: {
                                name: "status",
                                value: e.target.checked ? "ACTIVE" : "INACTIVE"
                              }
                            },
                            index
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col className='mt-2' md={4}>
                    <Form.Group controlId={`sequenceNumber-${index}`}>
                      <Form.Label>Addon Costing (₹) <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        type="number"
                        min={0}
                        placeholder='Addon Costing'
                        step="any"
                        name="productCost"
                        value={item.productCost}
                        onChange={(e) => handleGroupInputChange(e, index)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId={`orderType-${index}`}>
                        <Form.Label>
                            Order Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                            name="orderType"
                            value={item.orderType || ""}
                            onChange={(e) => handleGroupInputChange(e, index)}
                        >
                            <option value="ALL">ALL</option>
                            <option value="DELIVERY">DELIVERY</option>
                            <option value="PICKUP">PICK-UP</option>
                        </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col className='ms-3' md={1} style={{ display: 'flex', alignItems: 'center' }}>
                    {groupFormData.addonValues.length > 1 && (
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleRemoveAddonValueLocal(index)}
                      >
                        <TrashFill size={16} />
                      </Button>
                    )}
                  </Col>

                  <Col className='mt-2'>
                    <Form.Group>
                      <Form.Label >
                        Choose Selected Image
                      </Form.Label>
                      <Form.Control
                        id="selectedImage"
                        type="file"
                        accept="image/*"
                        onChange={handleSelectedImageChange(index)}
                      />
                    </Form.Group>
                  </Col>
                  <Col className='mt-2'>
                    <Form.Group>
                      <Form.Label>
                        Choose Unselected Image
                      </Form.Label>
                      <Form.Control
                        id="nonSelectedImage"
                        type="file"
                        accept="image/*"
                        onChange={handleUnSelectedImageChange(index)}
                      />
                    </Form.Group>
                  </Col>
                  <hr className='mb-0 mt-3' />
                </Row>
              ))}
              <Button variant="secondary" onClick={handleAddNewAddonValue}>
                Add More
              </Button>
              <hr />
              <Row>
                <Col>
                  <Form.Group controlId="groupExcludedOutlets">
                    <Form.Label className='fw-semibold'>Addon Group Excluded Outlets</Form.Label>
                    <Select
                      isMulti
                      options={outletData}
                      value={groupFormData.excludedOutlets}
                      onChange={(selected) => handleGroupSelectChange(selected, null, true)}
                      components={animatedComponents}
                      styles={customStyles}
                      placeholder="Select outlets..."
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="groupTitle">
                    <Form.Label className='fw-semibold'>Short Description</Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={groupFormData.description}
                      onChange={handleGroupInputChange}
                      placeholder="Enter Short Description"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setAddGroupModalOpen(false)}>
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : null}    

      {/* Modal for Editing an Entire Addon Group */}
      {editGroupModalOpen ? (
        <Modal show={editGroupModalOpen}  onHide={() => setEditGroupModalOpen(false)} size="lg">
          <Form onSubmit={handleEditGroupSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Addon Group</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {currentEditGroup && (
                <>
                  <Row className="mb-3 align-items-end">
                    <Col md={4}>
                      <Form.Group controlId="editGroupTitle">
                        <Form.Label className='fw-semibold'>Title <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          value={currentEditGroup?.title}
                          onChange={(e) => handleEditGroupInputChange(e, null)}
                          placeholder="Enter addon group title"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="groupIdentifier">
                        <Form.Label className='fw-semibold'>Seq No <span className='text-danger'>*</span></Form.Label>
                        <Form.Control
                          type="number"
                          min={0}
                          step="any"
                          name="sequenceNumbers"
                          value={currentEditGroup.sequenceNumber}
                          onChange={(e) => handleEditGroupInputChange(e, null)}
                          placeholder="Enter Sequence Number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                          <Form.Label className='fw-semibold'>
                              Order Type <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                              name="ordersType"
                              value={currentEditGroup.orderType || ""}
                              onChange={(e) => handleEditGroupInputChange(e, null)}
                          >
                              <option value="" disabled>Select</option>
                              <option value="ALL">ALL</option>
                              <option value="DELIVERY">DELIVERY</option>
                              <option value="PICKUP">PICK-UP</option>
                          </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="editGroupTitle">
                        <Form.Label className='fw-semibold'>Size Identifier</Form.Label>
                        <Form.Control
                          type="text"
                          name="identifier"
                          value={currentEditGroup?.identifier}
                          onChange={(e) => handleEditGroupInputChange(e, null)}
                          placeholder="Enter Size Identifier"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className='align-items-end'>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label className='fw-semibold'>
                          Choose Badge Image
                        </Form.Label>
                        <Form.Control
                          id="badgeImageInput"
                          type="file"
                          accept="image/*"
                          onChange={handleEditBadgeImageChange}
                        />
                        
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group controlId="editIsMultipleSelect" className="mt-2">
                        <div className="p-2 border rounded bg-light">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="fw-semibold">Selection Mode</span>
                            <span className={`badge ${currentEditGroup.isMultipleSelect ? 'bg-primary' : 'bg-secondary'}`}>
                              {currentEditGroup.isMultipleSelect ? 'Multiple' : 'Single'}
                            </span>
                          </div>
                          
                          <Form.Check
                            type="switch"
                            label={
                              <span className="fw-medium">
                                Allow multiple selection
                              </span>
                            }
                            name="isMultipleSelect"
                            checked={currentEditGroup.isMultipleSelect}
                            onChange={(e) => handleEditGroupInputChange(e, null)}
                            style={{ cursor: 'pointer' }}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    
                    <Col md={4}>
                      <Form.Group controlId="groupStatus">
                        <Form.Label className='fw-semibold'>Status</Form.Label>
                        <Form.Check
                          type="switch"
                          id="group-status-switch"
                          label={currentEditGroup.status === "ACTIVE" ? "Active" : "Inactive"}
                          checked={currentEditGroup.status === "ACTIVE"}
                          onChange={(e) =>
                            setCurrentEditGroup((prev) => ({
                              ...prev,
                              status: e.target.checked ? "ACTIVE" : "INACTIVE"
                            }))
                          }
                          style={{ cursor: 'pointer' }} 
                        />
                      </Form.Group>
                    </Col>
                    
                    <Col md="4">
                      {currentEditGroup.badgeImage && !removedBadgeImage && (
                        <div className="mt-1">
                          <img src={currentEditGroup.badgeImage} alt="Badge" width={80} height={80} />
                          <Button variant="outline-danger" size="sm" onClick={() => setRemovedBadgeImage(true)} className="ms-2">
                            Remove
                          </Button>
                        </div>
                      )}
                    </Col>
                  </Row>
                  
                  <hr />
                  <h5 className='fw-semibold'>ADDON VALUES</h5>
                  {currentEditGroup.addonValues.map((item, index) => (
                    <Row key={index} className="pt-1 mb-3 align-items-end" style={{ backgroundColor: 'whitesmoke' }}>
                      <Row>
                        <Col md={2}>
                          <Form.Group controlId={`editSequenceNumber-${index}`}>
                            <Form.Label>Seq. No. <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="number"
                              step="any"
                              min={0}
                              name="sequenceNumber"
                              value={item.sequenceNumber}
                              onChange={(e) => handleEditGroupInputChange(e, index)}
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group controlId={`editValue-${index}`}>
                            <Form.Label>Value <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="text"
                              name="value"
                              value={item.value}
                              onChange={(e) => handleEditGroupInputChange(e, index)}
                              placeholder="Enter value"
                              required
                            />
                          </Form.Group>
                        </Col>
                      
                        <Col md={5}>
                          <Form.Group controlId={`editExcludedOutlets-${index}`}>
                            <Form.Label>Excluded Outlets</Form.Label>
                            <Select
                              isMulti
                              options={outletData}
                              value={item.excludedOutlets}
                              onChange={(selected) => handleEditGroupSelectChange(selected, index)}
                              components={animatedComponents}
                              styles={customStyles}
                              placeholder="Select outlets..."
                            />
                          </Form.Group>
                        </Col>

                        <Col md={1} className='ms-3 mb-1' style={{ alignSelf: 'end' }}>
                          {currentEditGroup?.addonValues?.length > 1 && (
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleRemoveEditAddonValue(index)}
                            >
                              <TrashFill size={16} />
                            </Button>
                          )}
                        </Col>
                      </Row>

                      <Row className='mt-2 mb-1'>
                        <Col md={2}>
                          <Form.Group controlId={`editStatus-${index}`}>
                            <Form.Label className="mb-1">Status</Form.Label>
                            <Form.Check
                              type="switch"
                              id={`status-switch-${index}`}
                              label={item.status === "ACTIVE" ? "Active" : "Inactive"}
                              checked={item.status === "ACTIVE"}
                              onChange={(e) => {
                                handleEditGroupInputChange(
                                  {
                                    target: {
                                      name: "status",
                                      value: e.target.checked ? "ACTIVE" : "INACTIVE"
                                    }
                                  },
                                  index
                                );
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group controlId={`sequenceNumber-${index}`}>
                            <Form.Label>Addon Costing (₹) <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="number"
                              min={0}
                              placeholder='Addon Costing'
                              step="any"
                              name="productCost"
                              value={item.productCost}
                              onChange={(e) => handleEditGroupInputChange(e, index)}
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group controlId={`orderType-${index}`}>
                              <Form.Label>
                                  Order Type <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Select
                                  name="orderType"
                                  value={item.orderType || ""}
                                  onChange={(e) => handleEditGroupInputChange(e, index)}
                              >
                                  <option value="">Select Order Type</option>
                                  <option value="ALL">ALL</option>
                                  <option value="DELIVERY">DELIVERY</option>
                                  <option value="PICKUP">PICK-UP</option>
                              </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Col className='mt-2'>
                        <Form.Group>
                          <Form.Label >
                            Choose Selected Image
                          </Form.Label>
                          <Form.Control
                            id="selectedImage"
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleEditSelectedImageChange(e, index)}
                          />
                        </Form.Group>
                        {item.selectedImage && !removedSelectedImages[index] && (
                          <div className="mt-1">
                            <img src={item.selectedImage} alt="Selected" width={60} height={60} />
                            <Button variant="outline-danger" size="sm" onClick={() =>
                              setRemovedSelectedImages(prev => ({ ...prev, [index]: true }))
                            } className="ms-2">
                              Remove
                            </Button>
                          </div>
                        )}
                      </Col>
                      <Col className='mt-2'>
                        <Form.Group>
                          <Form.Label>
                            Choose Unselected Image
                          </Form.Label>
                          <Form.Control
                            id="nonSelectedImage"
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleEditUnSelectedImageChange(e, index)}
                          />
                        </Form.Group>
                        {item.nonSelectedImage && !removedNonSelectedImages[index] && (
                          <div className="mt-1">
                            <img src={item.nonSelectedImage} alt="Unselected" width={60} height={60} />
                            <Button variant="outline-danger" size="sm" onClick={() =>
                              setRemovedNonSelectedImages(prev => ({ ...prev, [index]: true }))
                            } className="ms-2">
                              Remove
                            </Button>
                          </div>
                        )}
                      </Col>

                      <hr className='mt-3 mb-0' />
                    </Row>
                  ))}
                  <Button variant="secondary" onClick={handleAddNewEditAddonValue}>
                    Add More
                  </Button>
                  <hr />

                  <Row>
                    <Col>
                      <Form.Group controlId="editGroupExcludedOutlets">
                        <Form.Label>Group Excluded Outlets</Form.Label>
                        <Select
                          isMulti
                          options={outletData}
                          value={currentEditGroup.excludedOutlets}
                          onChange={(selected) => handleEditGroupSelectChange(selected, null, true)}
                          components={animatedComponents}
                          styles={customStyles}
                          placeholder="Select outlets..."
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="editGroupTitle">
                        <Form.Label className='fw-semibold'>Short Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="description"
                          value={currentEditGroup.description}
                          onChange={(e) => handleEditGroupInputChange(e, null)}
                          placeholder="Enter Short Description"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setEditGroupModalOpen(false)}>
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                { isEditBtnLoading ? <Spinner size='sm' /> : "Save Changes" }
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : null}
      
      {/* Modal for Editing an Individual Addon Value */}
      {editValueModalOpen ? (
        <Modal show={editValueModalOpen} onHide={() => setEditValueModalOpen(false)} size="md" centered>
          <Form onSubmit={handleEditValueSubmit}>
            <Modal.Header
              closeButton
              style={{
                padding: "1rem 1.5rem"
              }}
            >
              <Modal.Title style={{ fontSize: "1.3rem", fontWeight: "600" }}>
                UPDATE ADDON VALUE
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "1.5rem" }}>
              {currentEditValue && (
                <>
                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="editValueSequenceNumber">
                        <Form.Label className="mb-1">
                          Seq. No. <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min={0}
                          step="any"
                          name="sequenceNumber"
                          value={currentEditValue.sequenceNumber}
                          onChange={handleEditValueInputChange}
                          placeholder="Enter sequence number"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="editValueValue">
                        <Form.Label className="mb-1">
                          Value <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="value"
                          value={currentEditValue.value}
                          onChange={handleEditValueInputChange}
                          placeholder="Enter value"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col className='mb-2' md={6}>
                      <Form.Group controlId="editValueProductCost">
                        <Form.Label>Addon Costing (₹) <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                          type="number"
                          min={0}
                          placeholder='Addon Costing'
                          step="any"
                          name="productCost"
                          value={currentEditValue.productCost}
                          onChange={handleEditValueInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="editValueOrderType">
                          <Form.Label>
                              Order Type <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                              name="orderType"
                              value={currentEditValue.orderType || ""}
                              onChange={handleEditValueInputChange}
                          >
                              <option value="" disabled>Select</option>
                              <option value="ALL">ALL</option>
                              <option value="DELIVERY">DELIVERY</option>
                              <option value="PICKUP">PICK-UP</option>
                          </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="editValueSelectedImage">
                        <Form.Label className="mb-1">Selected Image</Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setCurrentEditValue(prev => ({ ...prev, selectedImage: file }));
                            }
                          }}
                        />
                        {currentEditValue.selectedImage && (
                          <div className="mt-2">
                            <img
                              src={
                                typeof currentEditValue.selectedImage === "string"
                                  ? currentEditValue.selectedImage
                                  : URL.createObjectURL(currentEditValue.selectedImage)
                              }
                              alt="Selected Preview"
                              style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "0.5rem" }}
                            />
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="editValueNonSelectedImage">
                        <Form.Label className="mb-1">Non-Selected Image</Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setCurrentEditValue(prev => ({ ...prev, nonSelectedImage: file }));
                            }
                          }}
                        />
                        {currentEditValue.nonSelectedImage && (
                          <div className="mt-2">
                            <img
                              src={
                                typeof currentEditValue.nonSelectedImage === "string"
                                  ? currentEditValue.nonSelectedImage
                                  : URL.createObjectURL(currentEditValue.nonSelectedImage)
                              }
                              alt="Non-Selected Preview"
                              style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "0.5rem" }}
                            />
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>


                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          backgroundColor: "#f1f1f1",
                          borderRadius: "0.5rem",
                          padding: "1rem",
                          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)"
                        }}
                      >
                        <Form.Group controlId="editValueStatus" className="mb-1">
                          <Form.Label style={{ fontWeight: "600", color: "#333" }}>
                            Status
                          </Form.Label>
                          <Form.Check
                            type="switch"
                            id="editValue-status-switch"
                            label={
                              currentEditValue.status === "ACTIVE" ? "Active" : "Inactive"
                            }
                            checked={currentEditValue.status === "ACTIVE"}
                            onChange={(e) =>
                              handleEditValueInputChange({
                                target: {
                                  name: "status",
                                  value: e.target.checked ? "ACTIVE" : "INACTIVE"
                                }
                              })
                            }
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="editValueExcludedOutlets">
                        <Form.Label className="mb-1">Excluded Outlets</Form.Label>
                        <Select
                          isMulti
                          options={outletData}
                          value={currentEditValue.excludedOutlets}
                          onChange={(selected) => handleEditValueSelectChange(selected)}
                          components={animatedComponents}
                          styles={customStyles}
                          placeholder="Select outlets..."
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none", padding: "0.75rem 1.5rem" }}>
              <Button
                variant="secondary"
                onClick={() => setEditValueModalOpen(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
              >
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : null }

      {/* Modal for Adding an Individual Addon Value */}
      { addValueModalOpen ? (
        <Modal show={addValueModalOpen} onHide={() => setAddValueModalOpen(false)} size="md" centered>
          <Form onSubmit={handleEditValueSubmit}>
            <Modal.Header
              closeButton
              style={{
                padding: "1rem 1.5rem"
              }}
            >
              <Modal.Title className='fw-semibold' style={{ fontSize: "1.50rem" }}>
                {currentEditValue && currentEditValue._id ? "UPDATE ADDON VALUE" : "ADD NEW ADDON VALUE"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "1.5rem" }}>
              {currentEditValue && (
                <>
                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="editValueSequenceNumber">
                        <Form.Label className="mb-1">
                          Seq. No. <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min={0}
                          step="any"
                          name="sequenceNumber"
                          value={currentEditValue.sequenceNumber}
                          onChange={handleEditValueInputChange}
                          placeholder="Enter sequence number"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="editValueValue">
                        <Form.Label className="mb-1">
                          Value <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="value"
                          value={currentEditValue.value}
                          onChange={handleEditValueInputChange}
                          placeholder="Enter value"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                      <Col className='mb-2' md={6}>
                        <Form.Group controlId="editValueProductCost">
                          <Form.Label>Addon Costing (₹) <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="number"
                            min={0}
                            placeholder='Addon Costing'
                            step="any"
                            name="productCost"
                            value={currentEditValue.productCost}
                            onChange={handleEditValueInputChange}
                            required
                          />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="editValueOrderType">
                          <Form.Label>
                              Order Type <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                              name="orderType"
                              value={currentEditValue.orderType || ""}
                              onChange={handleEditValueInputChange}
                          >
                              <option value="" disabled>Select</option>
                              <option value="ALL">ALL</option>
                              <option value="DELIVERY">DELIVERY</option>
                              <option value="PICKUP">PICK-UP</option>
                          </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          backgroundColor: "#f1f1f1",
                          borderRadius: "0.5rem",
                          padding: "1rem",
                          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)"
                        }}
                      >
                        <Form.Group controlId="editValueStatus" className="mb-1">
                          <Form.Label style={{ fontWeight: "600", color: "#333" }}>
                            Status
                          </Form.Label>
                          <Form.Check
                            type="switch"
                            id="editValue-status-switch"
                            label={currentEditValue.status === "ACTIVE" ? "Active" : "Inactive"}
                            checked={currentEditValue.status === "ACTIVE"}
                            onChange={(e) =>
                              handleEditValueInputChange({
                                target: {
                                  name: "status",
                                  value: e.target.checked ? "ACTIVE" : "INACTIVE"
                                }
                              })
                            }
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="editValueExcludedOutlets">
                        <Form.Label className="mb-1">Excluded Outlets</Form.Label>
                        <Select
                          isMulti
                          options={outletData}
                          value={currentEditValue.excludedOutlets}
                          onChange={(selected) => handleEditValueSelectChange(selected)}
                          components={animatedComponents}
                          styles={customStyles}
                          placeholder="Select outlets..."
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Group controlId="selectedImage">
                        <Form.Label>Selected Image</Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            setCurrentEditValue((prev) => ({
                              ...prev,
                              selectedImage: e.target.files[0]
                            }))
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="nonSelectedImage">
                        <Form.Label>Non-selected Image</Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            setCurrentEditValue((prev) => ({
                              ...prev,
                              nonSelectedImage: e.target.files[0]
                            }))
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                </>
              )}
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none", padding: "0.75rem 1.5rem" }}>
              <Button variant="secondary" onClick={() => setAddValueModalOpen(false)}>
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Save {currentEditValue && currentEditValue._id ? "Changes" : "Value"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : null }
      

      <Modal
        show={confirmDeleteModalOpen}
        onHide={() => setConfirmDeleteModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this addon group?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmDeleteModalOpen(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => {
            handleDeleteGroup(groupIdToDelete);
            setConfirmDeleteModalOpen(false);
          }}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmDeleteValueModalOpen}
        onHide={() => setConfirmDeleteValueModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete Value</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this addon value?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmDeleteValueModalOpen(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => {
            handleDeleteAddonValue(deleteValueInfo.groupId, deleteValueInfo.valueId);
          }}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </React.Fragment>
  );
};

export default NewMenuAddons;